import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import BASE_URL from "api/Api";
import "assets/theme/admin_form.css";

const EditGallery = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category_id: "",
    title: "",
    description: "",
    image: null,
    is_main: false,
    is_active: true,
  });

  const [existingImage, setExistingImage] = useState(null);

  // Fetch Categories
  const fetchCategories = async () => {
    try {
      const res = await apiFetch(
        "leader_admin/get_gallery_categories"
      );
      setCategories(res.data || []);
    } catch (error) {
      alert(error.message);
    }
  };

  // Fetch Gallery Data
  const fetchGallery = async () => {
    try {
      setLoading(true);

      const res = await apiFetch(
        `leader_admin/get_gallery_by_id/${id}`
      );

      const data = res.data;

      setFormData({
        category_id: data.category_id || "",
        title: data.title || "",
        description: data.description || "",
        image: null,
        is_main: data.is_main || false,
        is_active: data.is_active ?? true,
      });

      setExistingImage(data.image || null);

    } catch (error) {
      alert(error.message || "डेटा मिळवताना त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchGallery();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;

    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const data = new FormData();
      data.append("category_id", formData.category_id);
      data.append("title", formData.title);
      data.append("description", formData.description);
      data.append("is_main", formData.is_main);
      data.append("is_active", formData.is_active);

      if (formData.image) {
        data.append("image", formData.image);
      }

      await apiFetch(
        `leader_admin/update_gallery/${id}`,
        {
          method: "PUT",
          body: data,
        }
      );

      alert("गॅलरी यशस्वीरित्या अपडेट झाली");
      navigate("/all_gallery");

    } catch (error) {
      alert(error.message || "अपडेट करताना त्रुटी आली");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                ✏️ गॅलरी संपादन (Edit Gallery Item)
              </h4>
              <small className="text-white-50">Update gallery image and details</small>
            </div>
          </div>

          <Link to="/all_gallery" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Gallery List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">

            {loading && (
              <div className="text-center mb-3">
                <div className="spinner-border text-primary" />
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="row g-4">

                {/* Category */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    गॅलरी विभाग
                  </label>
                  <select
                    className="form-select"
                    name="category_id"
                    value={formData.category_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="">निवडा</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Title */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    शीर्षक
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Description */}
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    वर्णन
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Existing Image */}
                {existingImage && (
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">
                      सध्याची प्रतिमा
                    </label>
                    <div className="border rounded-3 p-2 text-center">
                      <img
                        src={`${BASE_URL}/${existingImage}`}
                        alt="gallery"
                        className="img-fluid rounded"
                        style={{ maxHeight: "180px" }}
                      />
                    </div>
                  </div>
                )}

                {/* Replace Image */}
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    नवीन प्रतिमा (ऐच्छिक)
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="image"
                    accept="image/*"
                    onChange={handleChange}
                  />
                </div>

                {/* Main Toggle */}
                <div className="col-md-6">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="is_main"
                      checked={formData.is_main}
                      onChange={handleChange}
                    />
                    <label className="form-check-label">
                      ⭐ मुख्य इव्हेंट
                    </label>
                  </div>
                </div>

              </div>

              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  style={{ fontSize: "0.85rem" }}
                  disabled={loading}
                >
                  {loading ? "अपडेट होत आहे..." : "अपडेट करा"}
                </button>
              </div>

            </form>

          </div>
        </div>

      </div>
    </DashboardLayout>
  );
};

export default EditGallery;